import * as React from 'react';
import { getCurrentStock } from '../../features/StockManagement/Purchases/pdSlice';
import { useDispatch, useSelector } from 'react-redux';
import Navbar from '../setup/Navbar'
import { Container } from '@mui/material';
import StickyHeadTable from '../../BuiltInComponent/TableWithPagination';
import Loading from '../../BuiltInComponent/Loading';
export default function CurrentStock() {

    const dispatch = useDispatch();
    const { isLoading, currentStock } = useSelector((state) => state.pd);

    React.useEffect(() => {
        dispatch(getCurrentStock());
    }, [dispatch]);

    const onEditClick = async (itemCode) => {
        console.log('Edit Clicked', itemCode)
    }
    const onDeleteClick = async (itemCode) => {

    }

    const tableColumns = [
        { fieldName: 'itemCode', cName: 'Item Code', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'itemCode', cName: 'Item Code', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'itemDesc', cName: 'Item Description', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'currStock', cName: 'Current Stock', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'right', width: 80, status: 'dis', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'right', width: 80, status: 'dis', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'right', width: 80, status: 'dis', dType: 'string' },
    ];

    return (
        <>
            <Navbar />
            <Container>
                {isLoading ? <Loading /> : <StickyHeadTable tableColumns={tableColumns} tableData={currentStock && currentStock}
                    onEditClick={onEditClick} onDeleteClick={onDeleteClick} />
                }

            </Container>
        </>
    );
}